import styled from 'styled-components';
import tw from 'twin.macro';

/* The button ListViewSetToggle renders: the chevron plus the label the view
 * mode gives the set. Deliberately not the Button component - its size fixes
 * the label's type scale, and the label here is the set's own (a Meta on the
 * card's summary line, the resource name in the table). Only the chevron takes
 * its size from the button, via SVGIcon's 'inherit'. */
export const SetToggleButton = styled.button(
  tw`flex items-center min-w-0 p-0 m-0 -ml-2 bg-transparent border-0 text-xl text-left text-current cursor-pointer`
);
